import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getKioskSettings, updateKioskSettings } from './api';
import { kioskSettingsKeys } from './keys';
import { UpdateKioskSettingsBody } from './types';

export const useKioskSettings = ({
    centerId,
    enabled = true,
}: {
    centerId: string;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: kioskSettingsKeys.detail(centerId),
        queryFn: () => getKioskSettings({ centerId }),
        enabled: enabled && !!centerId,
        select: (data) => {
            if (!data?.data) return null;
            const raw = data.data as any;
            return { settings: raw.kioskSettings || raw };
        },
    });

export const useUpdateKioskSettings = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ centerId, body }: { centerId: string; body: UpdateKioskSettingsBody }) =>
            updateKioskSettings({ centerId, body }),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: kioskSettingsKeys.detail(variables.centerId) });
        },
    });
};
